export default __webpack_public_path__ + "static/lets_do_this-b86abc45cd3b547f27270e1dfa6e2f02.jpg";